var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        { style: { height: "100%" }, attrs: { grow: "" } },
        [
          _c(
            "w-col",
            {
              class: { "hidden-sm-down": !_vm.hideSubRoute },
              attrs: { md: "5", xl: "4", xs: "12" },
            },
            [
              _c(
                "w-card",
                { style: { height: "100%" } },
                [
                  _c(
                    "div",
                    { staticClass: "header cf" },
                    [
                      _c(
                        "div",
                        { staticClass: "title" },
                        [
                          _c("w-fa", {
                            staticClass: "mr",
                            attrs: { icon: "inbox" },
                          }),
                          _vm._v(" " + _vm._s(_vm.$ct("tickets-inbox")) + " "),
                        ],
                        1
                      ),
                      _c(
                        "w-button",
                        { attrs: { to: `${_vm.basePath}/new`, icon: "plus" } },
                        [_vm._v(" " + _vm._s(_vm.$ct("new-ticket")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-scroll-view",
                    { style: { height: "100%" } },
                    [
                      _c(
                        "w-list",
                        _vm._l(_vm.filteredTickets, function (ticket) {
                          return _c(
                            "w-list-item",
                            {
                              key: ticket.id,
                              class: {
                                active: ticket.id == _vm.$route.params.id,
                                unread: !ticket.isRead(),
                              },
                              attrs: { to: `${_vm.basePath}/${ticket.id}` },
                            },
                            [
                              _c("w-list-item-text", [
                                _c(
                                  "div",
                                  { staticClass: "title-box" },
                                  [
                                    !ticket.isRead()
                                      ? _c("div", {
                                          staticClass: "notification-dot",
                                        })
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      { staticClass: "time" },
                                      [
                                        ticket.priority == 3
                                          ? _c("w-fa", {
                                              staticClass: "priority",
                                              attrs: {
                                                icon: "exclamation-triangle mrs",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v("Ticket " + _vm._s(ticket.id)),
                                      ],
                                      1
                                    ),
                                    _c("w-spacer"),
                                    _c("app-timeago", {
                                      staticClass: "time",
                                      attrs: {
                                        datetime: ticket.timeLastMessage,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "status",
                                      class: _vm.statusClass(ticket.statusId),
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.statusText(ticket.statusId))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" " + _vm._s(ticket.subject) + " "),
                                ]),
                                _vm.showDossier && ticket.dossierName
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "w-chip",
                                          { staticClass: "dossier-chip" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "dossier-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(ticket.dossierName)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          attrs: { flat: "", icon: "filter" },
                          on: {
                            click: function ($event) {
                              _vm.toggleAllTickets = !_vm.toggleAllTickets
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.toggleAllTickets
                                  ? _vm.$ct("filter-open")
                                  : _vm.$ct("filter-all")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-col",
            {
              class: { hidden: _vm.hideSubRoute },
              attrs: { md: "7", xl: "8", xs: "12" },
            },
            [
              _c(
                "transition",
                { attrs: { mode: "out-in", name: "fast-fade" } },
                [
                  _c("router-view", {
                    key: _vm.$route.path,
                    on: {
                      archive: function ($event) {
                        return _vm.archive()
                      },
                      update: function ($event) {
                        return _vm.update()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }